<script setup>
  import { ref, computed } from 'vue';
  const props = defineProps({
    list: {
      type: Array,
      default: () => ([]),
    },
  });

  //#region data
  const isActive = ref(false);
  //#endregion

  //#region computed
  const firstItem = computed(() => {
    return props.list.length >= 1
      ? props.list[0]
      : null;
  });

  const restItems = computed(() => {
    return props.list.length > 1
      ? props.list.slice(1)
      : null;
  });
  //#endregion

  //#region methods
  const handleOpenDropdown = (event) => {
    isActive.value = event;
  };
  //#endregion
</script>

<template>
  <span
    v-if="firstItem"
    class="ui-table-links"
  >
    <span
      class="ui-table-links__first-value"
      :class="{
        'ui-table-links__first-value_has-rest': restItems
      }"
    >
      <img
        class="ui-table-links__icon"
        :src="firstItem.icon"
        :alt="firstItem.icon"
      >

      <a
        class="ui-table-links__link"
        target="_blank"
        :href="firstItem.text"
      >
        {{ firstItem.text }}
        <!-- <span class="ui-table-links__tooltip-hack">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </span> -->
      </a>
    </span>

    <ElDropdown
      v-if="restItems"
      trigger="click"
      placement="bottom"
      @visible-change="handleOpenDropdown"
    >
      <div
        class="ui-table-links__count"
        :class="{
          'ui-table-links__count_active': isActive,
        }"
      >
        {{ `+${restItems.length}` }}
      </div>

      <template v-slot:dropdown>
        <ElDropdownMenu class="ui-table-links__dropdown ddgroup">
          <div
            v-for="(platform, index) in restItems"
            :key="index"
            class="el-dropdown-menu__item"
          >
            <a
              class="ui-table-links__dropdown-text"
              target="_blank"
              :href="platform.text"
            >
              {{ platform.text }}
            </a>
          </div>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
  </span>

  <span v-else>-</span>
</template>

<style lang="scss">
  .ui-table-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__popper {
      font-size: 11px;
      font-weight: 600;
      line-height: normal;
      border-radius: 8px;
      background-color: rgba(48, 54, 52, 0.9);
      padding: 6px 8px;
    }

    &__first-value {
      display: flex;
      width: 100%;
      align-items: center;

      &_has-rest {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        // max-width: calc(100% - 30px);
        overflow-x: hidden;
      }
    }

    &__link {
      text-wrap: nowrap;
      color: var(--table-link-color);
      text-decoration: none;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    // данный хак нужен того, чтобы скорректировать показ overflow tooltip в таблице,
    // т.к.компонент таблицы использует innerText для определения показывать тултип или нет
    /*
      &__tooltip-hack {
        opacity: 0;
        display: inline-block;
        position: absolute;
      }
    */

    &__dropdown {
      &::before {
        opacity: 0;
      }
    }

    &__dropdown-text {
      color: var(--color-text-green);
      text-decoration: none;
      max-width: 400px;
      display: block;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &__count  {
      display: inline-block;
      border-radius: 4px;
      color: #3c3c3c;
      border: solid 1px var(--color-text-green);
      margin-left: 5px;
      padding: 0 5px;
      font-size: 10px;
      cursor: pointer;
      transition: all ease .25s;
      line-height: 17px;


      &_active,
      &:hover {
        background-color: var(--color-text-green);
        color: #fff;
      }
    }


    &__icon {
      margin-right: 4px;
      height: 15px;
    }
  }

</style>
